export default __webpack_public_path__ + "static/media/barcode-icon.21dbac19.svg";